import * as React from 'react';
import { Input } from './input';
import { Button, A11yButton } from '../button';
import { Glyphicon, IconsKey } from '../icons';

export type InputWithConfirmProps = {
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, value: string) => any;
  confirmButton?: string | React.ReactNode;
  onConfirm?: (
    e:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLInputElement>,
    value: string,
  ) => any;
  onEscape?: (e: React.KeyboardEvent<HTMLInputElement>) => any;
  icon?: IconsKey;
  defaultValue?: string;
  disabled?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  iconStyle?: React.CSSProperties;
  type?: string;
} & Stylable;

type InputWithConfirmState = {
  value: string;
};

export class InputWithConfirm extends React.Component<
  InputWithConfirmProps,
  InputWithConfirmState
> {
  constructor(props: InputWithConfirmProps, context: {}) {
    super(props, context);
    this.state = { value: props.defaultValue };
  }

  componentWillReceiveProps(nextProps: InputWithConfirmProps) {
    if (nextProps.value !== this.props.value)
      this.setState({ value: nextProps.value });
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const { onChange } = this.props;
    if (onChange) onChange(e, value);
    this.setState({ value });
  };

  handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { onConfirm, onEscape } = this.props;
    const { value } = this.state;
    const { key } = e;

    switch (key) {
      case 'Enter':
        if (onConfirm) onConfirm(e, value);
        break;
      case 'Escape':
        if (onEscape) onEscape(e);
        this.setState({ value: '' });
        break;
    }
  };

  renderConfirmButton() {
    const { onConfirm, confirmButton, icon } = this.props;
    const { value } = this.state;

    if (confirmButton) {
      return typeof confirmButton === 'string' ? (
        <Button content={confirmButton} onClick={e => onConfirm(e, value)} />
      ) : (
        confirmButton
      );
    }

    if (icon) {
      return typeof icon === 'string' ? (
        <A11yButton onClick={e => onConfirm(e, value)}>
          <Glyphicon glyph={icon} style={this.props.iconStyle} />
        </A11yButton>
      ) : (
        <A11yButton onClick={e => onConfirm(e, value)}>{icon}</A11yButton>
      );
    }
  }

  render() {
    const {
      value: _value,
      defaultValue,
      onChange,
      onConfirm,
      onEscape,
      confirmButton,
      icon,
      iconStyle,
      type,
      ...rest
    } = this.props;

    const { value } = this.state;

    return (
      <Input
        value={value ? value.toString() : ''}
        defaultValue={defaultValue}
        onChange={this.handleChange}
        onKeyUp={this.handleKeyUp}
        disabled={this.props.disabled}
        readOnly={this.props.readOnly}
        right={this.renderConfirmButton()}
        type={type}
        {...rest}
      />
    );
  }
}
